import { createSignal, Show } from "solid-js";

type Props = {
  open: boolean;
  displayName?: string;
  pending?: boolean;
  error?: string;
  onClose: () => void;
  onSubmit: (note: string) => void;
};

export function ConnectModal(props: Props) {
  const [note, setNote] = createSignal("");

  return (
    <Show when={props.open}>
      <div class="modal-backdrop" role="presentation" onClick={() => props.onClose()}>
        <div class="modal-card" role="dialog" onClick={(e) => e.stopPropagation()}>
          <h2>Connect with {props.displayName ?? "this attendee"}</h2>
          <p class="muted">Add an optional note — where you met, what you'd like to chat about.</p>
          <label class="field">
            <span>Note (optional)</span>
            <textarea
              rows={3}
              maxlength={280}
              value={note()}
              onInput={(e) => setNote(e.currentTarget.value)}
              placeholder="Great talk at the lakehouse session — keen to compare notes"
            />
          </label>
          <Show when={props.error}>
            <div class="error-box">{props.error}</div>
          </Show>
          <div class="wizard-actions">
            <button type="button" class="btn btn-ghost" onClick={() => props.onClose()} disabled={props.pending}>
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              disabled={props.pending}
              onClick={() => props.onSubmit(note())}
            >
              {props.pending ? "Sending…" : "Send request"}
            </button>
          </div>
        </div>
      </div>
    </Show>
  );
}